import {HpoRole} from "../../choices";


export function triageTabAccess(memberType) {
  return [HpoRole.ZOS, HpoRole.VLS, HpoRole.PHC, HpoRole.EVAC_MANAGER, HpoRole.POLICEMAN, HpoRole.FIREMAN].includes(memberType)
}

export function transportTabAccess(memberType) {
  return [HpoRole.ZOS, HpoRole.VLS, HpoRole.PHC, HpoRole.EVAC_MANAGER].includes(memberType)
}

export function identificationTabAccess(memberType) {
  return [HpoRole.ZOS, HpoRole.VLS, HpoRole.PHC, HpoRole.EVAC_MANAGER, HpoRole.ER,
    HpoRole.POLICEMAN, HpoRole.FIREMAN, HpoRole.IOS, HpoRole.CONTACT_POINT].includes(memberType)
}

export function hospitalRecordsTabAccess(memberType) {
  return [HpoRole.CONTACT_POINT, HpoRole.ER].includes(memberType)
}